var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName,"appear":_vm.transitionAppear}},[(_vm.shouldRender)?_c('div',_vm._g({class:_vm.shouldRender,style:(_vm.shouldRender)},_vm.$listeners),[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }